import React, { JSX, ReactElement, isValidElement } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import LoginForm from "../components/LoginForm";
import ScholarshipApplicationDetails from "../pages/ScholarshipApplication/ScholarshipApplicationDetails/ScholarshipApplicationDetails";
import Dashboard from "../pages/Dashboard/Dashboard";
import Layout from "../components/Layout/Layout";
import LoginPage from "../pages/LoginPage";
import ApplicationReview from "../pages/ApplicationReview/ApplicationReview";
import EvaluationForm from "../pages/ScholarshipApplication/EvaluationForm/EvaluationForm";
import ScholarshipApplicationView from "../pages/ScholarshipApplication/ScholarshipApplicationView/ScholarshipApplicationView";
import FundManagementList from "../pages/FundManagement/FundManagementList/FundManagementList";
import FundAllocation from "../pages/FundManagement/FundAllocation/FundAllocation";
import ApplicationStatus from "../pages/Applications/ApplicationStatus/ApplicationStatus";
import Landing from "../pages/Landing/Landing";
import LayoutOutside from "../components/LayoutOutside/LayoutOutside";
import AddiitionalDocuments from "../pages/Applications/AddiitionalDocs/AddiitionalDocuments";
import FundViewPayment from "../pages/FundManagement/FundViewPayment/FundViewPayment";
import FundAddPayment from "../pages/FundManagement/FundAddPayment/FundAddPaymentList";
import FundViewExpenses from "../pages/FundManagement/FundViewExpense/FundViewExpense";
import FundExpenseDetail from "../pages/FundManagement/FundExpenseDetail/FundExpenseDetail";
import StudentEvaluation from "../pages/QuarterlyEvaluation/StudentEvaluation/StudentEvaluation";
import PastStudentEvaluation from "../pages/QuarterlyEvaluation/StudentEvaluationHistory/PastStudentEvaluation";
import StudentEvaluationForm from "../pages/QuarterlyEvaluation/StudentEvaluationForm/StudentEvaluationForm";
import ScholarshipApplicationCreate from "../pages/ScholarshipApplication/ScholarshipApplicationCreate/ScholarshipApplicationCreate";
import ScholarshipSummary from "../pages/ScholarshipSummary/ScholarshipList/ScholarshipSummary";
import ScholarshipProfile from "../pages/ScholarshipSummary/ScholarshipProfile/ScholarshipProfile";
import EvaluationFundAllocation from "../pages/ScholarshipApplication/EvaluationFundAllocation/EvaluationFundAllocation";
import ScholarshipFundAllocation from "../pages/ScholarshipSummary/ScholarshipFundAllocation/ScholarshipFundAllocation";
import AttendancePortal from "../pages/Attendance/Attendance";
import ApplyApplication from "../pages/Applyapplication/Applyapplication";
import { APP_MAINPAGE_URL } from "../config/config";
import ManagementReports from "../pages/ManagementReports/ManagementReports";

const isAuthenticated = () => {
  return localStorage.getItem("authToken") || false
};

interface ProtectedRouteProps {
  children: JSX.Element;
}

interface UserData {
  modules?: string[];
  role_id?: number;
  user_id?: number;
}

const PublicRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
 if (isAuthenticated()) {
    const userData: UserData = JSON.parse(localStorage.getItem("userData") || "{}");
    const roleID = userData?.role_id || 1
    if(roleID === 2) {
      return <Navigate to={`/scholarship-summary/${userData?.user_id}`} replace />;
    } else {
      return <Navigate to="/" replace />;
    }
    
  }
  return <>{children}</>
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  if (!isAuthenticated()) {
    // return <Navigate to="/landing" replace />;
    window.location.href = APP_MAINPAGE_URL;
  }

  const userData: UserData = JSON.parse(localStorage.getItem("userData") || "{}");
  const allowedModules = userData?.modules || [];

  const updatedLayoutChildren = React.Children.map(
    children.props?.children,
    (routeWrapper: any) => {
      const updatedRoutes = React.Children.map(
        routeWrapper.props?.children,
        (route: any) => {
          let routeId=[]
          if(route?.props?.id) {
            routeId = route?.props?.id.split(',') 
          }
          routeId.forEach((data:string) => {
              if (!allowedModules.includes(data)) {
            // Wrap Navigate inside a Route so it’s valid
            return (
              <Route
                path={route?.props?.path}
                element={<Navigate to="/404" replace />}
              />
            );
          }
          })
        
          return route;
        }
      );

      return React.cloneElement(routeWrapper, { children: updatedRoutes });
    }
  );

  return React.cloneElement(children, {
    children: updatedLayoutChildren,
  });
};


const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route
        path="/landing"
        element={
          <LayoutOutside>
            <Landing />
          </LayoutOutside>
        }
      />
      <Route
        path="/applyapplication"
        element={
          <LayoutOutside>
            <ApplyApplication />
          </LayoutOutside>
        }
      />
      <Route
        path="/applicationstatus"
        element={
          <LayoutOutside>
            <ApplicationStatus />
          </LayoutOutside>
        }
      />
      <Route
        path="/additionaldocs/:id"
        element={
          <LayoutOutside>
            <AddiitionalDocuments />
          </LayoutOutside>
        }
      />
      <Route
        path="/applicationcreate"
        element={
          <LayoutOutside>
            <ScholarshipApplicationDetails />
          </LayoutOutside>
        }
      />
      <Route
        path="/applicationnew"
        element={
          <LayoutOutside>
            <ScholarshipApplicationCreate />
          </LayoutOutside>
        }
      />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} id="admin-dashboard" />
                <Route
                  path="/application-management"
                  element={<ApplicationReview />}
                  id="application-management"
                />
                <Route
                  path="/application-management/:id"
                  element={<ScholarshipApplicationDetails />}
                  id="application-management"
                />
                <Route
                  path="/application-management-view/:id"
                  element={<ScholarshipApplicationView />}
                  id="application-management"
                />

                <Route path="/scholarship-summary" element={<ScholarshipSummary />} id="scholarship-summary,student-profile" />
                <Route path="/scholarship-summary/:id" element={<ScholarshipProfile />} id="scholarship-summary,student-profile" />
                <Route
                  path="/scholarship-summary/:id/scholarshipfund"
                  element={<ScholarshipFundAllocation />}
                  id="scholarship-summary,student-profile"
                />
                <Route
                  path="/fund-management"
                  element={<FundManagementList />}
                  id="fund-management"
                />
                <Route
                  path="/fund-viewpayment/:id"
                  element={<FundViewPayment />}
                  id="fund-management,student-payment-history"
                />
                <Route
                  path="/fund-addpayment/:id"
                  element={<FundAddPayment />}
                  id="fund-management"
                />
                <Route
                  path="/fund-viewexpense/:id"
                  element={<FundViewExpenses />}
                  id="fund-management,student-expense-summary"
                />
                <Route
                  path="/fund-viewexpensedetail/:type/:id"
                  element={<FundExpenseDetail />}
                  id="fund-management,student-expense-summary"
                />
                <Route
                  path="/management-reports/:type"
                  element={<ManagementReports />}
                  id="management-reports"
                />
                <Route path="/evaluation/:id" element={<EvaluationForm />} id="quarterly-evaluation" />
                <Route
                  path="/evaluation/:id/evaluationfund"
                  element={<EvaluationFundAllocation />}
                  id="quarterly-evaluation"
                />
                <Route
                  path="/evaluation/:id/fundallocation"
                  element={<FundAllocation />}
                  id="quarterly-evaluation"
                />
                <Route
                  path="/student-evaluation"
                  element={<StudentEvaluation />}
                  id="quarterly-evaluation"
                />
                <Route
                  path="/student-evaluation-view/:id"
                  element={<PastStudentEvaluation />}
                  id="quarterly-evaluation"
                />
                <Route
                  path="/student-evaluation-new/:id"
                  element={<StudentEvaluationForm />}
                  id="quarterly-evaluation"
                />
                <Route
                  path="/student-evaluation-new"
                  element={<StudentEvaluationForm />}
                  id="quarterly-evaluation"
                />
                <Route
                  path="/attendance"
                  element={<AttendancePortal />}
                  id="attendance"
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
